import R from 'ramda';
import Link from '@cotyorg/ccx-atoms/Link';
import Strong from '../../Strong';
import Extlink from '../../Extlink';

export const componentMap = {
  'b': {
    component: Strong,
  },
  'url': {
    component: Link,
    valueProp: 'link',
  },
  'exturl': {
    component: Extlink,
    valueProp: 'link',
  },
};

const tagRegex = R.compose(
  tags => new RegExp(`\\[\\/?(${tags})(=[^\\]]*)?\\]`, 'g'),
  R.join('|'),
  R.keys,
)(componentMap);

export const stripBBCode = R.ifElse(
  value => typeof value === 'string',
  R.replace(tagRegex, ''),
  R.identity,
);

export { default as parse } from './parse';
